export default __webpack_public_path__ + "static/media/trezor.5e24c1af.svg";